export enum CmUiBugType {
	INFO = 'info',
	WARN = 'warning',
	SUCCESS = 'check',
	HELP = 'help',
}
